import React, {memo} from "react";
import Label from "components/general/Label"
import { arraysEqual } from "helpers/utils";
import Esl from "components/common/Esl";
import Competitor from "components/presentation/Competitor";
import useViewport from "components/general/useViewPort";

export const TableExpandedIndivual = memo((props) => {    
    const {breakPoint} = useViewport();
    const isMobile = breakPoint === "sm" || breakPoint === "xs" 
    const {row, status} = props;  
    let esl = row?.extCompetitor;
    //console.log(row);
    const out = (<>
        <Esl data={esl} status={status}/>
        <table className={isMobile ? 'table-borderless' : 'table-borderless ms-5'}>
            <tbody>
                <Entries row={row}/>
            </tbody>
        </table>
    </>)

    return <>{out}</>

}, (prevProps, nextProps) => {
    //Si retornamos true:  No se renderiza
    //Si retornamos false: Si se renderiza
    //renderizamos cuando un dato de los visibles cambia
    //return false;
    return arraysEqual(prevProps?.row?.eventUnitEntries, nextProps?.row?.eventUnitEntries);
});

export const TableExpandedGroups = memo((props) => {    
    const {breakPoint} = useViewport();
    const isMobile = breakPoint === "sm" || breakPoint === "xs" 
    const {row, status} = props;  
    let esl = row?.extCompetitor;
    const out = (<>
        <Esl data={esl} status={status} />
        <table className={isMobile ? 'table-borderless' : 'table-borderless ms-5'}>
            <tbody>
                <tr>
                    <td className="align-top">
                        <table className="table-borderless">
                            <tbody>
                                <Athletes row={row} />
                            </tbody>
                        </table>
                    </td>
                    <td className="align-top">
                        <table className="table-borderless">
                            <tbody>
                                <Entries row={row}/>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </tbody>
        </table>
    </>)

    return <>{out}</>

}, (prevProps, nextProps) => {
    //Si retornamos true:  No se renderiza
    //Si retornamos false: Si se renderiza
    //renderizamos cuando un dato de los visibles cambia
    //return false;
    return arraysEqual(prevProps?.row?.eventUnitEntries, nextProps?.row?.eventUnitEntries);
});


const Athletes = ({row}) => {
    if (!row?.teamAthletes || !Array.isArray(row.teamAthletes) || row.teamAthletes.length === 0) return ''
    row.teamAthletes.sort((a, b) => a?.order - b?.order);
    return row.teamAthletes.map(d => (<tr key={d?.order}><td><Competitor {...d.athlete} hidePicture={true} hideNoc={true}/></td></tr>))
}

const Entries = ({row}) => {
    return (<>
        <tr>
            <td className="text-start fw-bold"><Label data='HeaderMusicLength' /></td>
            <td>{row?.eventUnitEntries?.find(eue => eue?.eue_code === 'MUSIC_LENGTH')?.eue_value}</td>
        </tr>
        <tr>
            <td className="text-start fw-bold"><Label data='HeaderTitle' /></td>
            <td>{row?.eventUnitEntries?.find(eue => eue?.eue_code === 'MUSIC_TITLE')?.eue_value}</td>
        </tr>
        <tr>
            <td className="text-start fw-bold"><Label data='HeaderComposer' /></td>
            <td>{row?.eventUnitEntries?.find(eue => eue?.eue_code === 'MUSIC_COMPOSER')?.eue_value}</td>
        </tr>
        <tr>
            <td className="text-start fw-bold"><Label data='HeaderPerformer' /></td>
            <td>{row?.eventUnitEntries?.find(eue => eue?.eue_code === 'MUSIC_PER')?.eue_value}</td>
        </tr>
    </>)

}